import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import Select from 'react-select';

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

export class Ver_add_whatsapp_campaign extends Component {
    constructor(props) {
        super(props);
        this.handleSave = this.handleSave.bind(this);
        this.onChangeCampaignName = this.onChangeCampaignName.bind(this);
        this.onChangeCampaignMessage = this.onChangeCampaignMessage.bind(this);
        this.handleClusterChange = this.handleClusterChange.bind(this);
        this.handleCollectionChange = this.handleCollectionChange.bind(this);
        this.handleBannerChange = this.handleBannerChange.bind(this);
        this.onChangeDiscountPercentage = this.onChangeDiscountPercentage.bind(this);
        this.onChangeScheduledDate = this.onChangeScheduledDate.bind(this);
        this.onChangeActiveFrom = this.onChangeActiveFrom.bind(this);
        this.onChangeActiveUntil = this.onChangeActiveUntil.bind(this);
        this.onChangeMaxUsesPerUser = this.onChangeMaxUsesPerUser.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);

        this.state = {
            campaign_name: "",
            whatsapp_message: "",
            selectedCluster: null,
            selectedCollection: null,
            selectedBanner: null,
            discount_percentage: "",
            campaign_status: "DRAFT",
            scheduled_date: "",
            active_from: "",
            active_until: "",
            max_uses_per_user: "",
            clusters: [],
            collections: [],
            banners: [],
            errors: {},
            loading: false,
        }
    }

    componentWillMount() {
        this.getDataClusters();
        this.getDataCollections();
        this.getDataBanners();
    }

    getDataClusters(){
        var user = AuthService.getCurrentUser();
        ApiService.getCustomerClusters(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const clusters = res.data.map(function(row) {
                        return {
                            value: row.id,
                            label: row.cluster_name
                        }
                    })
                    this.setState({ clusters: clusters });
                }
            },
            error => {
            }
        );
    }

    onChangeCampaignName(e) {
        this.setState({
            campaign_name: e.target.value
        });
    }

    onChangeCampaignMessage(e) {
        this.setState({
            whatsapp_message: e.target.value
        });
    }

    getDataCollections(){
        var user = AuthService.getCurrentUser();
        ApiService.getProductCollections(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const collections = res.data
                        .filter(row => row.collection_status === 'ACTIVO')
                        .map(function(row) {
                            return {
                                value: row.id,
                                label: row.collection_name
                            }
                        });
                    this.setState({ collections: collections });
                }
            },
            error => {
            }
        );
    }

    getDataBanners(){
        var user = AuthService.getCurrentUser();
        ApiService.getDataBanners(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const banners = res.data.map(function(row) {
                        return {
                            value: row.id,
                            label: row.name || `Banner ${row.id}`
                        }
                    });
                    this.setState({ banners: banners });
                }
            },
            error => {
            }
        );
    }

    handleClusterChange = (selectedOption) => {
        this.setState({ selectedCluster: selectedOption });
    };

    handleCollectionChange = (selectedOption) => {
        this.setState({ selectedCollection: selectedOption });
    };

    handleBannerChange = (selectedOption) => {
        this.setState({ selectedBanner: selectedOption });
    };

    onChangeDiscountPercentage(e) {
        this.setState({
            discount_percentage: e.target.value
        });
    }

    onChangeScheduledDate(e) {
        this.setState({
            scheduled_date: e.target.value
        });
    }

    onChangeActiveFrom(e) {
        this.setState({
            active_from: e.target.value
        });
    }

    onChangeActiveUntil(e) {
        this.setState({
            active_until: e.target.value
        });
    }

    onChangeMaxUsesPerUser(e) {
        this.setState({
            max_uses_per_user: e.target.value
        });
    }

    onChangeStatus(e) {
        this.setState({
            campaign_status: e.target.value
        });
    }

    handleSave(e) {
        e.preventDefault();

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            if (!this.state.selectedCluster) {
                toast.error("Por favor selecciona un grupo de clientes.");
                return;
            }

            // Validar que la fecha de inicio esté presente
            if (!this.state.active_from) {
                toast.error("Por favor selecciona la fecha de inicio de la campaña.");
                return;
            }

            // Validar que la fecha de fin esté presente
            if (!this.state.active_until) {
                toast.error("Por favor selecciona la fecha de fin de la campaña.");
                return;
            }

            // Validar que la fecha de fin sea posterior a la fecha de inicio
            if (this.state.active_from && this.state.active_until) {
                const dateFrom = new Date(this.state.active_from);
                const dateUntil = new Date(this.state.active_until);
                if (dateUntil <= dateFrom) {
                    toast.error("La fecha de fin debe ser posterior a la fecha de inicio.");
                    return;
                }
            }

            this.setState({
                message: "",
                loading: true
            });

            var user = AuthService.getCurrentUser();
            let data_campaign = {
                'campaign_name': this.state.campaign_name,
                'whatsapp_message': this.state.whatsapp_message,
                'id_cluster': this.state.selectedCluster.value,
                'id_collection': this.state.selectedCollection ? this.state.selectedCollection.value : null,
                'discount_percentage': this.state.discount_percentage || null,
                'id_banner': this.state.selectedBanner ? this.state.selectedBanner.value : null,
                'campaign_status': this.state.campaign_status,
                'scheduled_date': this.state.scheduled_date || null,
                'active_from': this.state.active_from || null,
                'active_until': this.state.active_until || null,
                'max_uses_per_user': this.state.max_uses_per_user || null,
            }

            ApiService.postWhatsappCampaign(user.token, data_campaign).then(
            (res) => {
                if(res){
                    if(res.status == 'success')
                    {
                        this.props.history.push("/whatsapp-campaigns");
                        toast.success("Campaña creada!");
                    }
                    else
                    {
                        toast.error(res.message || "Error al crear la campaña");
                        this.setState({
                            loading: false
                        });
                    }
                }else{
                    toast.error("Error al procesar la solicitud");
                    this.setState({
                        loading: false
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();

              this.setState({
                loading: false
              });

              toast.error(resMessage);
            }
          );
        }
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Crear Campaña de WhatsApp" parent="Promociones" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Crear Nueva Campaña de WhatsApp</h5>
                                </div>
                                <div className="card-body">
                                <Form
                                    onSubmit={this.handleSave}
                                    ref={c => {
                                        this.form = c;
                                    }}
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Nombre de la Campaña</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="campaign_name"
                                                placeholder="Ej: Campaña Navideña 2025"
                                                value={this.state.campaign_name}
                                                onChange={this.onChangeCampaignName}
                                                validations={[required]}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Mensaje de WhatsApp</label>
                                        <div className="col-md-7">
                                            <textarea
                                                className="form-control"
                                                name="whatsapp_message"
                                                rows="4"
                                                placeholder="Ej: ¡Tenemos algo increíble para ti hoy! Ingresa a la web y entérate de nuestras promociones exclusivas."
                                                value={this.state.whatsapp_message}
                                                onChange={this.onChangeCampaignMessage}
                                                required
                                            />
                                            <small className="form-text text-muted">
                                                Este es el mensaje genérico que se enviará por WhatsApp. No incluyas promociones específicas aquí.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Grupo de Clientes</label>
                                        <div className="col-md-7">
                                            <Select
                                                value={this.state.selectedCluster}
                                                onChange={this.handleClusterChange}
                                                options={this.state.clusters}
                                                placeholder="Selecciona un grupo de clientes..."
                                                isClearable={true}
                                            />
                                            <small className="form-text text-muted">
                                                Selecciona el grupo de clientes que recibirá esta campaña.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Colección de Productos</label>
                                        <div className="col-md-7">
                                            <Select
                                                value={this.state.selectedCollection}
                                                onChange={this.handleCollectionChange}
                                                options={this.state.collections}
                                                placeholder="Selecciona una colección de productos..."
                                                isClearable={true}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Selecciona la colección de productos para esta campaña.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Porcentaje de Descuento</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="number"
                                                className="form-control"
                                                name="discount_percentage"
                                                placeholder="Ej: 10"
                                                min="0"
                                                max="100"
                                                step="0.01"
                                                value={this.state.discount_percentage}
                                                onChange={this.onChangeDiscountPercentage}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Ingresa el porcentaje de descuento (0-100).
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Banner</label>
                                        <div className="col-md-7">
                                            <Select
                                                value={this.state.selectedBanner}
                                                onChange={this.handleBannerChange}
                                                options={this.state.banners}
                                                placeholder="Selecciona un banner..."
                                                isClearable={true}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Banner que aparecerá cuando el cliente entre al link de la campaña.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Fecha Programada</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="datetime-local"
                                                className="form-control"
                                                name="scheduled_date"
                                                value={this.state.scheduled_date}
                                                onChange={this.onChangeScheduledDate}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Fecha y hora en que se enviará automáticamente la campaña.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Fecha de Inicio</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="datetime-local"
                                                className="form-control"
                                                name="active_from"
                                                value={this.state.active_from}
                                                onChange={this.onChangeActiveFrom}
                                            />
                                            <small className="form-text text-muted">
                                                Fecha desde la cual la campaña estará activa.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Fecha de Fin</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="datetime-local"
                                                className="form-control"
                                                name="active_until"
                                                value={this.state.active_until}
                                                onChange={this.onChangeActiveUntil}
                                            />
                                            <small className="form-text text-muted">
                                                Fecha hasta la cual la campaña estará activa.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Usos Máximos por Usuario</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="number"
                                                className="form-control"
                                                name="max_uses_per_user"
                                                placeholder="Ej: 3"
                                                min="1"
                                                value={this.state.max_uses_per_user}
                                                onChange={this.onChangeMaxUsesPerUser}
                                            />
                                            <small className="form-text text-muted">
                                                Opcional. Cantidad máxima de veces que un usuario puede usar esta campaña.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Estado</label>
                                        <div className="col-md-7">
                                            <select
                                                name="campaign_status"
                                                className="form-control"
                                                value={this.state.campaign_status}
                                                onChange={this.onChangeStatus}
                                            >
                                                <option value="DRAFT">BORRADOR</option>
                                                <option value="PROGRAMADA">PROGRAMADA</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="pull-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={this.state.loading}
                                        >
                                            {this.state.loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                            )}
                                            Guardar
                                        </button>
                                    </div>
                                    <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                        this.checkBtn = c;
                                        }}
                                    />
                                </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_add_whatsapp_campaign
